import './src/styles/global.css';
export { wrapRootElement } from './src/components/Layout/RootWrapper';

// Reveal the page once Gatsby has routed to the correct page.
export const onRouteUpdate = () => {
  document.documentElement.style.visibility = '';
};
